// extracted by css-extract-rspack-plugin
export default {"titleWithShield":"RestrictionShield-module__titleWithShield__u4tNK","restrictionShield":"RestrictionShield-module__restrictionShield__iToSK"};